module.exports = __webpack_public_path__ + "assets/2.4bb60c01.png";